module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-sidebar-d7ee672e.svg";